import type { Tokens } from '../../../../theming/types'

export default (config: { tokens: Tokens }) => {
  const { tokens } = config
  return {
    default: {
      fieldset: {
        '& > &, .selectionControlGroupNestedWrap': {
          marginBlock: '12px 0',
          marginInline: '28px 0',
        },

        '.selectionControlGroupItemBottomMargin': {
          marginBlockEnd: '8px',
        },

        [`
        .selectionControlGroupItem + .selectionControlGroupItem,
        .selectionControlGroupNestedWrap + .selectionControlGroupItem
      `]: {
          marginBlockStart: '12px',
        },
      },

      legend: {
        ...tokens.fontElementLabel,
        marginBlockEnd: '8px',
      },
    },
  } as const
}
